module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1137.62b50880.png";